export default {
   email: "info@sjr-erlangen.de"
};